<template>
  <div
    :id
    class="paragraph-tags mb-spacing-base"
    :class="{
      container: !parentType,
    }"
  >
    <ul class="flex flex-wrap gap-2" :aria-label="$texts('tags')">
      <li v-for="(tag, i) in visibleTags" :key="i" class="pill">
        {{ tag }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTagsFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const props = defineProps<{
  tags?: ParagraphTagsFragment['tags']
}>()

const { $texts } = useEasyTexts()

const { index, siblings, parentType } = defineBlokkli({
  bundle: 'tags',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)

const visibleTags = computed(() => filterNullArray(props.tags))
</script>

<style lang="postcss">
.paragraph-tags {
  .pill {
    @apply inline-block whitespace-nowrap rounded-full border border-solid border-primary text-size-6 font-bold text-primary;
    padding: 2.5px 15px;
  }
}
</style>
